import { useParams } from "react-router-dom";
import MainNewRequest from "../../components/new-request/main-new-request";

function NewRequest() {
  const { requestId } = useParams();
  
  return (
    <div className="w-[90%] lg:w-[95%] mx-auto mt-8">
        <MainNewRequest requestId={requestId} />
    </div>
  );
}

export default NewRequest;


